import { render, staticRenderFns } from "./v-order-confirmation-addresses.vue?vue&type=template&id=2dbaff65&scoped=true"
import script from "./v-order-confirmation-addresses.vue?vue&type=script&lang=js"
export * from "./v-order-confirmation-addresses.vue?vue&type=script&lang=js"
import style0 from "./v-order-confirmation-addresses.vue?vue&type=style&index=0&id=2dbaff65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbaff65",
  null
  
)

export default component.exports